/* eslint-disable */

import request from '@/utils/request'

export function getListBuildingApi(query) {
  return request({
    url: '/config-service/v1/hotel/building',
    method: 'get',
    params: query
  })
}
export function getListBuildingByHotelIdApi(query) {
  return request({
    url: '/config-service/v1/hotel/building/building-by-hotel',
    method: 'get',
    params: query
  })
}
export function getAllBuildingApi() {
  return request({
    url: '/config-service/v1/hotel/building/all',
    method: 'get'
  })
}

export function addBuildingApi(query) {
  return request({
    url: '/config-service/v1/hotel/building',
    method: 'post',
    data: query
  })
}

export function updateBuildingApi(query) {
  return request({
    url: '/config-service/v1/hotel/building',
    method: 'put',
    data: query
  })
}
export function deleteBuildingApi(query) {
  return request({
    url: '/config-service/v1/hotel/building',
    method: 'delete',
    data: query
  })
}
